export default __webpack_public_path__ + "static/media/G3.983c916d.png";